import { render, staticRenderFns } from "./DiagramRoot.vue?vue&type=template&id=20c2cfd5&"
import script from "./DiagramRoot.vue?vue&type=script&lang=js&"
export * from "./DiagramRoot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/max/WORK/vue-diagram-editor/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20c2cfd5')) {
      api.createRecord('20c2cfd5', component.options)
    } else {
      api.reload('20c2cfd5', component.options)
    }
    module.hot.accept("./DiagramRoot.vue?vue&type=template&id=20c2cfd5&", function () {
      api.rerender('20c2cfd5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DiagramRoot.vue"
export default component.exports